import * as React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { DocumentTitle, Icon, LinkContainer, PageHeader, Spinner } from "components/common";
import { Button, ButtonToolbar, Col, Row } from "components/bootstrap";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import usePermissions from "hooks/usePermissions";
import { useWatchlist } from "watchlist/hooks/useWatchlistsV2";
import WatchlistEntries from "watchlist/components/WatchlistEntries";
import SetDefaultTtlModal from "watchlist/components/SetDefaultTtlModal";
import WatchlistRoutes from "watchlist/Routes";
const WatchlistDetailsPage = () => {
  const { watchlistId } = useParams();
  const { data: watchlist, isLoading } = useWatchlist(watchlistId);
  const { isPermitted } = usePermissions();
  const canEdit = isPermitted("watchlist:edit");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showTtlModal, setShowTtlModal] = useState(false);
  const queryClient = useQueryClient();
  const { t } = useTranslation("enterprise_search");
  const title = watchlist ? `${watchlist.name}` : t("watchlist_details_page.watchlist");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title,
      actions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, canEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => setShowAddModal(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "add" }), " ", t("watchlist_details_page.add_entries")), canEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: () => setShowTtlModal(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "schedule" }), " ", t("watchlist_details_page.set_default_ttl")), /* @__PURE__ */ React.createElement(LinkContainer, { to: WatchlistRoutes.LIST }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "default" }, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_back" }), " ", t("watchlist_details_page.back_to_watchlists"))))
    },
    /* @__PURE__ */ React.createElement("span", null, t("watchlist_details_page.description"))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(LicenseCheck, { licenseSubject: LICENSE_SUBJECTS.security, featureName: "watchlists", hideChildren: true }, isLoading || !watchlist ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(
    WatchlistEntries,
    {
      watchlistId: watchlist.id,
      watchlistName: watchlist.name,
      showAddModal,
      onCloseAddModal: () => setShowAddModal(false)
    }
  )))), showTtlModal && watchlist && /* @__PURE__ */ React.createElement(
    SetDefaultTtlModal,
    {
      watchlistId: watchlist.id,
      watchlistName: watchlist.name,
      currentTtlSeconds: watchlist.default_ttl_seconds,
      onClose: () => setShowTtlModal(false),
      onUpdated: () => queryClient.invalidateQueries({ queryKey: ["watchlists", "v2"] })
    }
  ));
};
export default WatchlistDetailsPage;
